import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import * as Sentry from '@sentry/react';

import ErrorText from '../ErrorText';
import Button from '../inputs/Button';
import useBrowserStorageState from '../../hooks/useBrowserStorageState';

const FORCE_REFRESH_STORAGE_KEY = 'atad-page-has-been-force-refreshed';

export default function GlobalErrorFallback({ error }) {
  useEffect(() => {
    if (error) {
      Sentry.captureException(error);
    }
  }, [error]);

  const [forceRefreshState, setForceRefreshState] = useBrowserStorageState(
    'localStorage',
    FORCE_REFRESH_STORAGE_KEY,
    false
  );
  const navigate = useNavigate();

  useEffect(() => {
    console.log(`forceRefreshState: ${forceRefreshState}`);
  }, [forceRefreshState]);

  function handleReloadClick() {
    if (!forceRefreshState) {
      setForceRefreshState(true);
      window.location.reload();
    } else {
      setForceRefreshState(false);
      navigate('/dashboard');
      window.location.reload();
    }
  }

  return (
    <div className="flex flex-col h-screen w-screen justify-center items-center">
      <div className="mb-6">
        {!forceRefreshState && (
          <ErrorText message="We've run into an error. Please try reloading with the button below." />
        )}
        {forceRefreshState && (
          <ErrorText message="Looks like we're still experiencing the same error. Let's send you back home." />
        )}
      </div>
      <Button type="text" onClick={handleReloadClick} primary>
        {forceRefreshState ? 'Back Home' : 'Reload'}
      </Button>
    </div>
  );
}
